import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  backStagePurchase,
  backStagePaymentMethod,
  cleanErrors,
  cleanStatesPurchaseMobile,
} from '../../../actions/purchaseActions';
import { formatURL } from '../../../utils';
import matomoTracker from '../../../utils/matomo';
import dataLayer from '../../../utils/dataLayer';

class StagePayment extends Component {
  constructor(props) {
    super(props);

    this.backStage = this.backStage.bind(this);
    this.title = this.title.bind(this);
  }

  getStepTitle = () => {
    const payments = [
      { value: this.props.stepDisplayCreditCard, name: 'stepDisplayCreditCard' },
      { value: this.props.stepDisplayCashTransfer, name: 'stepDisplayCashTransfer' },
      { value: this.props.stepDisplayBoleto, name: 'stepDisplayBoleto' },
      { value: this.props.stepDisplayPix, name: 'stepDisplayPix' },
    ];

    const selected_payment = payments.filter((payment) => payment.value > 0) || [{ value: 0 }];

    if (this.props.stagePurchase === 1) {
      return 'Compra - Segurados';
    } else if (this.props.stagePurchase === 2) {
      if (selected_payment.length !== 0) {
        if (selected_payment[0].name === 'stepDisplayCreditCard') {
          if (selected_payment[0].value === 1) return 'Compra - Selecione o cartão';
          if (selected_payment[0].value === 2) return 'Compra - Parcelamento';
          if (selected_payment[0].value === 3) return 'Compra - Dados do cartão';
        } else if (selected_payment[0].name === 'stepDisplayCashTransfer') {
          if (selected_payment[0].value === 1) return 'Compra - Selecione o banco';
          if (selected_payment[0].value === 2) return 'Compra - Dados da transferência';
        } else {
          if (selected_payment[0].value === 1) return 'Compra - Responsável pelo pagamento';
        }
      }
      return 'Compra - Forma de pagamento';
    } else if (this.props.stagePurchase === 3) {
      return 'Compra - Contato da compra';
    } else {
      return 'Compra - Tudo pronto!';
    }
  };

  getStepName = () => {
    const stageMap = { 1: 'segurados', 2: 'pagamento', 3: 'contato', 4: 'confirmacao' };
    return stageMap[this.props.stagePurchase] || 'segurados';
  };

  trackCurrentStep = () => {
    if (this.props.mobile) {
      matomoTracker.trackPageView(this.getStepTitle());
    }
  };

  componentDidMount() {
    this.trackCurrentStep();
    dataLayer.checkoutStepView(this.getStepName(), 'forward');
  }

  componentDidUpdate(prevProps) {
    const mobileJustActivated = !prevProps.mobile && this.props.mobile;

    const stepChanged =
      prevProps.stagePurchase !== this.props.stagePurchase ||
      prevProps.stepDisplayCreditCard !== this.props.stepDisplayCreditCard ||
      prevProps.stepDisplayCashTransfer !== this.props.stepDisplayCashTransfer ||
      prevProps.stepDisplayBoleto !== this.props.stepDisplayBoleto ||
      prevProps.stepDisplayPix !== this.props.stepDisplayPix;

    if (mobileJustActivated || stepChanged) {
      this.trackCurrentStep();
    }

    if (prevProps.stagePurchase !== this.props.stagePurchase) {
      const direction = this.props.stagePurchase > prevProps.stagePurchase ? 'forward' : 'backward';
      dataLayer.checkoutStepView(this.getStepName(), direction);
    }
  }

  backStage = () => {
    const payments = [
      { value: this.props.stepDisplayCreditCard, name: 'stepDisplayCreditCard' },
      { value: this.props.stepDisplayCashTransfer, name: 'stepDisplayCashTransfer' },
      { value: this.props.stepDisplayBoleto, name: 'stepDisplayBoleto' },
      { value: this.props.stepDisplayPix, name: 'stepDisplayPix' },
    ];

    const selected_payment = payments.filter((payment) => payment.value > 0) || [{ value: 0 }];

    if (selected_payment.length !== 0) {
      if (selected_payment[0].value === 1 && this.props.stagePurchase === 2) {
        this.props.backStagePaymentMethod(selected_payment[0].value - 1, selected_payment[0].name, true);
      } else if (selected_payment[0].value > 1 && this.props.stagePurchase === 2) {
        this.props.backStagePaymentMethod(selected_payment[0].value - 1, selected_payment[0].name, false);
      } else {
        this.props.backStagePurchase(this.props.stagePurchase);
      }
    } else {
      this.props.backStagePurchase(this.props.stagePurchase);
    }
  };

  title = () => {
    const payments = [
      { value: this.props.stepDisplayCreditCard, name: 'stepDisplayCreditCard' },
      { value: this.props.stepDisplayCashTransfer, name: 'stepDisplayCashTransfer' },
      { value: this.props.stepDisplayBoleto, name: 'stepDisplayBoleto' },
      { value: this.props.stepDisplayPix, name: 'stepDisplayPix' },
    ];

    const selected_payment = payments.filter((payment) => payment.value > 0) || [{ value: 0 }];

    if (this.props.stagePurchase === 1) {
      return <span>Segurados</span>;
    } else if (this.props.stagePurchase === 2) {
      if (selected_payment.length !== 0) {
        if (selected_payment[0].name === 'stepDisplayCreditCard') {
          if (selected_payment[0].value === 1) {
            return <span>Selecione o cartão</span>;
          }
        } else if (selected_payment[0].name === 'stepDisplayCashTransfer') {
          if (selected_payment[0].value === 1) {
            return <span>Selecione o banco</span>;
          }
        } else {
          if (selected_payment[0].value === 1) {
            return <span>Responsável pelo pagamento</span>;
          }
        }
      }
      return <span>Forma de pagamento</span>;
    } else if (this.props.stagePurchase === 3) {
      return <span>Contato da compra</span>;
    } else {
      return <span>Tudo pronto!</span>;
    }
  };

  backSearch = (e) => {
    const location = {
      pathname: formatURL(
        this.props.match,
        `/pesquisa/${this.props.match.params.destination}/${this.props.match.params.begin_date}/${this.props.match.params.end_date}/`,
        null
      ),
    };

    this.props.cleanStatesPurchaseMobile();
    this.props.cleanErrors();
    this.props.history.push(location);
  };

  render() {
    if (!this.props.mobile) {
      return <div />;
    }

    return (
      <div className="stage-payment">
        <div className="back-stage" onClick={this.props.stagePurchase === 1 ? this.backSearch : this.backStage}>
          <img src="/assets/images/icons/leftArrow.svg" alt="" /> {this.title()}
        </div>
        <div className='stage-count'>
          {this.props.stagePurchase !== 4 && (
            <span>
              Etapa <strong>0{this.props.stagePurchase}</strong> de <strong>03</strong>
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      mobile: state.mobile.mobileActive,
      stagePurchase: state.purchase.stagePurchase,
      stepDisplayCreditCard: state.purchase.stepDisplayCreditCard,
      stepDisplayCashTransfer: state.purchase.stepDisplayCashTransfer,
      stepDisplayBoleto: state.purchase.stepDisplayBoleto,
      stepDisplayPix: state.purchase.stepDisplayPix,
    }),
    {
      backStagePurchase,
      backStagePaymentMethod,
      cleanErrors,
      cleanStatesPurchaseMobile,
    }
  )(StagePayment)
);



// WEBPACK FOOTER //
// ./src/components/purchase/stage_payment/StagePayment.jsx